"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporateStronghold = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const TileType_1 = require("../../TileType");
class CorporateStronghold extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CORPORATE_STRONGHOLD,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 11,
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 3 }),
            metadata: {
                cardNumber: '182',
                description: 'Decrease your Energy production 1 step and increase your M€ production 3 steps. Place a City tile.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(1).br;
                        pb.plus().megacredits(3);
                    }).nbsp().nbsp().city();
                }),
                victoryPoints: -2,
            },
        });
    }
    canPlay(player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1 &&
            player.game.board.getAvailableSpacesForCity(player).length > 0;
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select space for city tile', player.game.board.getAvailableSpacesForCity(player), TileType_1.TileType.CITY, (space) => {
            player.game.addCityTile(player, space.id);
            player.addProduction(Resources_1.Resources.ENERGY, -1);
            player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
            return undefined;
        });
    }
    getVictoryPoints() {
        return -2;
    }
}
exports.CorporateStronghold = CorporateStronghold;
//# sourceMappingURL=CorporateStronghold.js.map